<template>
    <div v-if="!hide" class="form-network form-network-youtube">
       <details open>
           <summary>{{ $t('dash.post-creator.form.youtube.visibility') }}<i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
                <SelectComponent :valueSelect="formDataNetwork.visibility" :changeValueSelect="changeVisibilityPost" :data="{all:$t('dash.post-creator.form.youtube.visibility-public'), private:$t('dash.post-creator.form.youtube.visibility-private'),unlisted:$t('dash.post-creator.form.youtube.visibility-unlisted')}"  :positionAuto="false" :positionX="'left'"></SelectComponent>
                <div class="type-switch">
                    {{ $t('dash.post-creator.form.youtube.notify-subscribers') }}
                    <ComponentSwitch :value="formDataNetwork.notifySubscribers" :onChange="(v)=> formDataNetwork.notifySubscribers = v" :id="'switch-settings-advanced-youtube-1'"></ComponentSwitch>
                </div>
                <div class="type-switch">
                    {{ $t('dash.post-creator.form.youtube.children-content') }}
                    <ComponentSwitch :value="formDataNetwork.contentForChildren" :onChange="(v)=>{formDataNetwork.contentForChildren = v}" :id="'switch-settings-advanced-youtube-2'"></ComponentSwitch>
                </div>
           </div>      
       </details>
       <details open>
           <summary>{{ $t('dash.post-creator.form.youtube.category') }}<i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
                <SelectComponent 
                    :valueSelect="formDataNetwork.category ? formDataNetwork.category : '22'" 
                    :changeValueSelect="selectCategory" 
                    :data="this.$store.getters['postCreator/youtubeCategories'].length ? Object.fromEntries(this.$store.getters['postCreator/youtubeCategories'].map(category => [category.id.toString(), category.snippet.title])) : {'22' : 'People & Blogs'}"  
                    :positionAuto="false" 
                    :positionX="'left'"
                />     
           </div>      
       </details>
       <details open>
           <summary>Tags<i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail content-detail-tag">
                <div class="list-tags" v-if="formDataNetwork.tags.length">
                    <div class="tag" v-for="(tag,index) in formDataNetwork.tags" @click="()=>removeTag(tag)" :key="index">{{ tag }} <i class="fa-solid fa-circle-xmark" ></i></div>
                </div>
                <div class="type-input">
                    <input :placeholder="$t('dash.post-creator.form.youtube.add-tag')" v-model="inputModel.tag" @keyup.enter="()=> addTag()">
                </div>
           </div>      
       </details>
       <details open>
           <summary>{{ $t('dash.post-creator.form.youtube.playlist') }}<i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
                <div class="selects">
                    <SelectComponent 
                        :valueSelect="pageSelectedSelectPlayList" 
                        :changeValueSelect="(v)=>inputModel.pageSelectForSelectPlaylist = v" 
                        :data="pageYoutubeSelected.length ? {...Object.fromEntries(pageYoutubeSelected.map(p => [p.id, p.name]))} : {}"   
                        :positionAuto="false" :positionX="'left'">
                    </SelectComponent>
                    <SelectComponent 
                        :valueSelect="valueSelectPlayList" 
                        :changeValueSelect="selectPlaylist" 
                        :data="listPlaylistForSelect"  
                        :positionAuto="false" 
                        :positionX="'left'"
                    />
                        
                </div>
           </div>      
       </details>
   </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SelectComponent from '@/components/dash/utils/select.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            SelectComponent
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },

            formDataNetwork: {
                type: Object,
                default: () => ({})
            },

            idPageRenderNetworkSelected: Number,
        
        },
       
        data() {
            return {
                    inputModel:{
                        tag: '',
                        pageSelectForSelectPlaylist : null,
                        playlistSelectedPerPage : {},
                        idCategorySelect: "22"
                    },

                    playlistsPages: {
                        //idPage: {}
                    },

                    lastModeSelected : undefined
            }
        },

       
        async mounted() {
            if (this.formData.formDataNetwork.youtube) this.formDataNetwork = this.formData.formDataNetwork.youtube

            await this.updateYoutubeCategoriesInStore()

            if (!this.inputModel.pageSelectForSelectPlaylist && this.pageYoutubeSelected[0]) {
                this.inputModel.pageSelectForSelectPlaylist = this.pageYoutubeSelected[0].id
            }

            for (const page of this.pageYoutubeSelected) {
                const existing = this.$store.getters['postCreator/getDataInPage'](page.id, 'youtubePlaylist')
                if (!existing || !existing.length) {
                    await this.updatePlaylistContentInStore(page.id)
                }
            }
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },
            changeVisibilityPost(state) {
                    this.formDataNetwork.visibility = state
                    this.$emit('setFormDataNetwork', 'youtube', this.formDataNetwork)
            },
            addTag() {
                this.formDataNetwork.tags = [...this.formDataNetwork.tags.filter(tag => tag.toLowerCase() !== this.inputModel.tag.toLowerCase()), this.inputModel.tag]
                this.$emit('setFormDataNetwork', 'youtube', this.formDataNetwork)
                this.inputModel.tag = ''
            },
            removeTag(tagName) {
                this.formDataNetwork.tags = this.formDataNetwork.tags.filter(tag => tag.toLowerCase() !== tagName.toLowerCase())
                this.$emit('setFormDataNetwork', 'youtube', this.formDataNetwork)
            },
            
            async updateYoutubeCategoriesInStore() {
                if (this.$store.getters['postCreator/youtubeCategories'].length) return

                for (let i = 0; i < this.pageYoutubeSelected.length; i++) {
                    const page = this.pageYoutubeSelected[i];

                    try {
                        if (page.bots && page.bots[0]) {
                            const result = await this.getYoutubeCategories(page.bots[0].id, this.$i18n.locale);
                            if (result && result.body && result.body.categories) {
                                this.$store.commit('postCreator/setYoutubeCategories', result.body.categories);
                                break; 
                            }
                        }
                    } catch (error) {
                        console.error('An error occurred while fetching YouTube categories:', error);
                    }
                }
            },

            async updatePlaylistContentInStore(pageId) {
                console.log('updatePlaylistContentInStore')
                try {
                    const page = this.pagesSelected.find(page => (page.id == pageId))
                    console.log('updatePlaylistContentInStore page',page)
                    if (page && page.bots && page.bots[0]) {
                        const resultPlaylists = await this.getYoutubePlaylists(page.bots[0].id);
                        if (resultPlaylists && resultPlaylists.body && resultPlaylists.body.playlists) {
                           
                            this.$store.commit('postCreator/setDataInPageStorage', {
                                pageId,
                                dataName: 'youtubePlaylist',
                                data: resultPlaylists.body.playlists
                            });
                        }
                    }
                } catch (error) {
                    console.error('An error occurred while fetching YouTube playlists:', error);
                }
            },

            selectPlaylist(playlistId) {
                if (playlistId == 'none' && this.formDataNetwork.playlistSelectedByPage[this.pageSelectedSelectPlayList]) {
                    this.$delete(this.formDataNetwork.playlistSelectedByPage, this.pageSelectedSelectPlayList);
                }else{
                    console.log("testest",playlistId)
                    this.$set(this.formDataNetwork.playlistSelectedByPage, this.pageSelectedSelectPlayList, playlistId)
                }
                this.$emit('setFormDataNetwork', 'youtube', this.formDataNetwork)
            },

            selectCategory(idCategory) {
                // console.log("selectCategory", idCategory)
                // this.inputModel.idCategorySelect = idCategory
                this.formDataNetwork.category = idCategory
                this.$emit('setFormDataNetwork', 'youtube', this.formDataNetwork)
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            listPlaylistForSelect() {
                const pageId = this.inputModel.pageSelectForSelectPlaylist && this.pageYoutubeSelected.some(page=>page.id == this.inputModel.pageSelectForSelectPlaylist) ? this.inputModel.pageSelectForSelectPlaylist : this.pageYoutubeSelected.length ? this.pageYoutubeSelected[0].id : null
                if (pageId) {
                    const playlist = this.$store.getters['postCreator/getDataInPage'](pageId, 'youtubePlaylist');
                    console.log("playlistplaylist",pageId, playlist)
                    if (playlist && playlist.length)  {
                        return {none:this.$t('dash.post-creator.form.youtube.no-playlist'), ...Object.fromEntries(playlist.map(playlist => [playlist.id, playlist.snippet.title]))}
                    }  
                }
              

                return {none:this.$t('dash.post-creator.form.youtube.no-playlist')}
            },

            valueSelectPlayList() {
                return this.formDataNetwork.playlistSelectedByPage && this.pageSelectedSelectPlayList && this.formDataNetwork.playlistSelectedByPage[this.pageSelectedSelectPlayList] ? this.formDataNetwork.playlistSelectedByPage[this.pageSelectedSelectPlayList] : 'none'
            },

            pageSelectedSelectPlayList() {
                return this.inputModel.pageSelectForSelectPlaylist && this.pageYoutubeSelected.some(page=>page.id == this.inputModel.pageSelectForSelectPlaylist) ? this.inputModel.pageSelectForSelectPlaylist : this.pageYoutubeSelected.length ? this.pageYoutubeSelected[0].id : null
            },

            pageYoutubeSelected() {
                return this.idPageRenderNetworkSelected ? this.pagesSelected.filter(p => p.network == 'youtube' && p.id == this.idPageRenderNetworkSelected) : this.pagesSelected.filter(p => p.network == 'youtube')
            }
        },

        watch: {

            async pageYoutubeSelected(newValue,oldValue) {
           
                if ((!this.inputModel.pageSelectForSelectPlaylist || !this.pageYoutubeSelected.find((p) => p.id == this.inputModel.pageSelectForSelectPlaylist)) && this.pageYoutubeSelected[0]) {
                    this.inputModel.pageSelectForSelectPlaylist = this.pageYoutubeSelected[0].id
                }
                await this.updateYoutubeCategoriesInStore()
 
                const oldIds = new Set(oldValue.map(item => item.id));
                newValue.forEach(async (page) => {
                    if (!oldIds.has(page.id)) {
                        await this.updatePlaylistContentInStore(page.id)
                    }
                });
            },

            ['formData.formDataNetwork.youtube']() {
                if (this.formData.formDataNetwork.youtube) this.formDataNetwork = this.formData.formDataNetwork.youtube
            },
        },


       beforeDestroy () {
       }
       
   }
</script>